var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgThunder(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 25,
    viewBox: "0 0 17 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.5347 1.58008H10.539H10.5347ZM10.5347 1.58008L8.7718 10.8422L15.1581 10.8637L6.46516 23.4199L8.22805 13.2301L1.84211 13.2078L10.5347 1.58008ZM10.5359 0.0176041C10.4937 0.0176041 10.4515 0.0191422 10.4101 0.0222427C10.1343 0.0445328 9.95149 0.13672 9.73471 0.282423C9.61265 0.363805 9.50259 0.461895 9.40776 0.57383C9.37928 0.607425 9.35242 0.64236 9.32727 0.678517L0.57219 12.2656C0.226486 12.7395 0.175705 13.3649 0.44133 13.8875C0.706565 14.4102 1.24289 14.7414 1.83078 14.7457L6.34094 14.7785L4.92297 23.1328C4.78821 23.8508 5.17102 24.5664 5.84485 24.8547C6.04067 24.9389 6.2516 24.9822 6.46474 24.9821C6.95576 24.9821 7.35927 24.7524 7.66203 24.3375L16.428 11.7813C16.7738 11.3074 16.8242 10.6812 16.5589 10.1594C16.2937 9.6367 15.7573 9.30542 15.1695 9.30115L10.6593 9.29334L12.062 1.94763C12.0918 1.82737 12.1067 1.70394 12.1066 1.58006C12.1066 0.734743 11.4335 0.0456802 10.5913 0.0183365C10.5726 0.0175552 10.5542 0.0175552 10.5359 0.0175552L10.5359 0.0176041Z",
    fill: "#707070"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgThunder);
export default __webpack_public_path__ + "static/media/thunder.ee6aeee35749db4199fdcf60958dc297.svg";
export { ForwardRef as ReactComponent };